const doc = [({"en":({"js":({"admin":({"tenant_photo_products":({"visible_in_shop":({"the_tenant_photo_product_was_saved":"The tenant photo product was saved."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;